import {shieldCheckSvg as Icon__small__shieldCheckSvg} from '../Icon__small/Icon__small--shieldCheck.js'

export var shieldCheck = {
  name: 'shieldCheck',
  category: 'icon',
  colorable: true,
  svg: Icon__small__shieldCheckSvg,
};
